<div class="entity-onboard-wrapper">
    <div class="d-flex justify-space-between mb-3 cursor">
    <div class="exp-header">{{ data?.msg }}</div>
    <img alt="file" src="../../../../assets/images/x-close.svg" (click)="onFormActionClick('no')"/>
    </div>
    <div class="exp-content">
    <div class="download-option" (click)="downloadOptionSelection('alertBackwards')">
        <div class="d-flex gap-10">
            <img alt="file" src="../../../../assets/images/fileUploadIcon.svg"/>
            <div class="mt-2 w-10"> Telemetry history from alert backwards </div>
        </div>
        <img *ngIf="alertBackwards" alt="tick" src="../../../../assets/images/download-checkbox.svg"/>
    </div>
    <div class="download-option" (click)="downloadOptionSelection('alertForward')"> 
        <div class="d-flex gap-10">
            <img alt="file" src="../../../../assets/images/fileUploadIcon.svg"/>
            <div class="mt-2 w-10"> Telemetry history from alert forward </div>
        </div>
        <img *ngIf="alertForward" alt="tick" src="../../../../assets/images/download-checkbox.svg"/>
    </div>
    </div>
    <div class="eo-action-list -end">
      <app-button [label]="'No'" [color]="buttonColor" (click)="onFormActionClick('no')">
      </app-button>
      <app-button [label]="'Yes'" [disabled]="!alertForward && !alertBackwards" (click)="onFormActionClick('yes')">
      </app-button>
    </div>
  </div>